module.exports = __webpack_public_path__ + "static/media/cleanWater.920219df.png";